import Axios from 'axios';
import { context } from './backend';

let ready = false;

const instance = Axios.create({
    timeout: 30000,
    withCredentials: false,
    maxContentLength: 128 * 1024 * 1024,
    dataType: 'json',
    contentType: 'application/json',
    accept: '*/*',
    // headers: {
    //   'Cache-Control': 'max-age=0, no-cache, must-revalidate, proxy-revalidate',
    // },
});

function setConfig(config) {
    return new Promise((resolve, reject) => {
        if (!ready) {
            if (context.cfmToken) {
                config.headers['Authorization'] = `Bearer ${context.cfmToken}`;
                instance.defaults.headers['Authorization'] = `Bearer ${context.cfmToken}`;
                config.baseURL = context.cfmBaseUrl;
                instance.defaults.baseURL = context.cfmBaseUrl;
                ready = true;
                resolve(config);
            } else {
                reject({
                    code: 'invalid-token',
                    message: 'FM bridge-backend axiosCfm setConfig invalid token',
                });
            }
        } else {
            resolve(config);
        }
    });
}

instance.interceptors.request.use(
    (config) => {
        return setConfig(config);
    },
    (error) => {
        return Promise.reject(error);
    },
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error;

        if (response && response.status === 401 && response.data && response.data.code === '2') {
            const retryOriginalRequest = new Promise((resolve) => {
                window.fmDevFunctions.expiredDevLoginToken();
                resolve();
            });

            return retryOriginalRequest;
        }

        return Promise.reject(error);
    },
);

export const axiosCfm = instance;
